import { render, staticRenderFns } from "./EditPurchaseLimit.vue?vue&type=template&id=0bf201ec"
import script from "./EditPurchaseLimit.vue?vue&type=script&lang=js"
export * from "./EditPurchaseLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditPurchaseLimit.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bf201ec')) {
      api.createRecord('0bf201ec', component.options)
    } else {
      api.reload('0bf201ec', component.options)
    }
    module.hot.accept("./EditPurchaseLimit.vue?vue&type=template&id=0bf201ec", function () {
      api.rerender('0bf201ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/EditPurchaseLimit.vue"
export default component.exports